var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"news_single_page"}},[_c('news-navbar'),_c('news-details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }